import { ArrowLeft, Building2, Phone, Mail, MapPin, CreditCard, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
          <h1 className="text-4xl font-bold">Impressum</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-12 space-y-10">
          
          {/* Company Info */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <Building2 className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900">AKW Design</h2>
            </div>
            <p className="text-slate-600 text-lg">Inhaber: Adrian Wojciechowski</p>
          </section>

          {/* Address */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center">
                <MapPin className="w-5 h-5 text-slate-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Adresse</h2>
            </div>
            <div className="text-slate-600 space-y-1">
              <p>Jakob-Mankel-Straße 20</p>
              <p>35781 Weilburg</p>
              <p>Deutschland</p>
            </div>
          </section>

          {/* Contact */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <Phone className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Kontakt</h2>
            </div>
            <div className="space-y-2">
              <a href="tel:+4915510904109" className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors">
                <Phone className="w-4 h-4" />
                <span>+49 155 10904109</span>
              </a>
              <a href="mailto:akw-design@gmx.de" className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors">
                <Mail className="w-4 h-4" />
                <span>akw-design@gmx.de</span>
              </a>
            </div>
          </section>

          {/* Business Status */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-slate-100 rounded-xl flex items-center justify-center">
                <FileText className="w-5 h-5 text-slate-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Unternehmensstatus</h2>
            </div>
            <p className="text-slate-600">
              Kleinunternehmer gemäß §19 UStG.<br />
              Es wird keine Umsatzsteuer ausgewiesen.
            </p>
          </section>

          {/* Bank Details */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                <CreditCard className="w-5 h-5 text-teal-600" />
              </div>
              <h2 className="text-xl font-bold text-slate-900">Bankverbindung für Überweisungen</h2>
            </div>
            <div className="bg-slate-50 rounded-xl p-4 space-y-2">
              <p className="text-slate-600"><span className="font-medium text-slate-700">Empfänger:</span> Adrian Wojciechowski</p>
              <p className="text-slate-600"><span className="font-medium text-slate-700">IBAN:</span> <span className="font-mono">DE43 1001 0178 3526 3057 81</span></p>
              <p className="text-slate-600"><span className="font-medium text-slate-700">Bank:</span> Revolut Bank UAB</p>
            </div>
          </section>

          {/* Legal Sections */}
          <section className="border-t border-slate-200 pt-10">
            <h2 className="text-xl font-bold text-slate-900 mb-4">Haftung für Inhalte</h2>
            <p className="text-slate-600 leading-relaxed">
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Haftung für Links</h2>
            <p className="text-slate-600 leading-relaxed">
              Unsere Website enthält möglicherweise Links zu externen Websites Dritter, auf deren 
              Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch 
              keine Gewähr übernehmen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">Urheberrecht</h2>
            <p className="text-slate-600 leading-relaxed">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
              der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <Link to="/">
            <Button variant="outline" className="rounded-full px-8">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
